import { useCurrentUserContext } from '../providers/user/use-current-user-context';
import { UserRole } from '@/types';
import { Navigate } from 'react-router-dom';

export function ClientRoute({ children }: { children: React.ReactNode }) {
  const { user } = useCurrentUserContext();

  if (user?.role !== UserRole.USER) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
